module.exports = __webpack_public_path__ + "static/img/avatar2.5ca54b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/avatar2.png
// module id = nxhq
// module chunks = 0